module.exports = __webpack_public_path__ + "static/media/page4small.67743162.png";